var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 100,
    viewBox: "0 0 1440 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1439.85 65.909C1439.85 29.174 1456.92 44.8536 1359.61 58.2932C1262.31 71.7329 1153.06 17.2276 960.154 41.2697C767.252 65.3118 639.22 73.5249 478.753 73.5249C319.993 73.5249 164.647 55.6053 79.2923 33.6539C-6.06255 11.7024 -0.941259 -22.3447 -0.941259 20.6622C-0.941259 63.6691 -0.941259 99.9562 -0.941259 99.9562H79.2923C159.526 99.9562 319.993 99.9562 478.753 99.9562C639.22 99.9562 799.687 99.9562 960.154 99.9562C1118.91 99.9562 1279.38 99.9562 1359.61 99.9562H1439.85C1439.85 99.9562 1439.85 102.644 1439.85 65.909Z",
    fill: "#DAF6E9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.df7b560b565491e4886705acbd32789b.svg";
export { ForwardRef as ReactComponent };